import { render, staticRenderFns } from "./certList.vue?vue&type=template&id=a2ef01a4&scoped=true"
import script from "./certList.vue?vue&type=script&lang=js"
export * from "./certList.vue?vue&type=script&lang=js"
import style0 from "./certList.vue?vue&type=style&index=0&id=a2ef01a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ef01a4",
  null
  
)

export default component.exports